import { Link } from "react-router-dom";
import AnimatedSection from "../../../components/base/AnimatedSection";

const collaborators = [
  {
    id: "tiki-taka",
    name: "TIKI TAKA BARCELONA",
    tagline: "Organización y Gestión de Eventos Deportivos · B2C & B2B",
    description:
      "Tiki Taka Barcelona es un grupo con más de 6 años de actividad dedicado a la organización y gestión de eventos deportivos B2C y B2B. Su objetivo es que la experiencia del cliente sea única e irrepetible, ofreciendo ligas de fútbol 7, fútbol 5, fútbol sala, fútbol media, fútbol empresa y torneos. Actualmente, más de 30 colaboradores de la liga ya son gestionados íntegramente por Fair Play Global.",
    category: "Colaborador Principal",
    featured: true,
  },
];

export default function CollaboratorsGrid() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Featured collaborator */}
        {collaborators.map((collab) => (
          <AnimatedSection key={collab.id} className="mb-16">
            <div
              className={`${
                collab.featured ? "border-2 border-brand-red" : "border border-brand-pearl"
              } rounded-lg overflow-hidden`}
            >
              <div className="flex flex-col lg:flex-row">
                {/* Logo area */}
                <div className="lg:w-2/5 bg-brand-pearl flex items-center justify-center p-16">
                  <div className="w-full max-w-xs flex items-center justify-center">
                    <img
                      src="https://storage.readdy-site.link/project_files/96850ced-79ff-4b51-89fe-ffb6c70cf0e4/870f7db6-15a0-4bbb-856a-e88a2f97b259_tiki_taka_barcelona_logo.jpeg?v=2f69d1ca39f373b278ba39aeba24496e"
                      alt="Tiki Taka Barcelona logo"
                      className="w-full h-auto object-contain"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="lg:w-3/5 p-12 flex flex-col justify-center">
                  <span className="inline-block font-body text-xs font-medium text-brand-red tracking-widest uppercase mb-4 border border-brand-red px-3 py-1 rounded-full w-fit">
                    {collab.category}
                  </span>
                  <h3 className="font-heading font-black text-brand-black text-3xl mb-2 tracking-tight">
                    {collab.name}
                  </h3>
                  <p className="font-body text-brand-gray-mid text-sm mb-6 italic">
                    {collab.tagline}
                  </p>
                  <div className="w-10 h-0.5 mb-6" style={{ backgroundColor: "#E8150C" }}></div>
                  <p className="font-body text-brand-anthracite text-base leading-relaxed mb-8">
                    {collab.description}
                  </p>
                  {/* Stats */}
                  <div className="flex gap-8">
                    <div>
                      <p className="font-heading font-black text-brand-red text-3xl">+6</p>
                      <p className="font-body text-brand-gray-mid text-xs uppercase tracking-wider">Años de actividad</p>
                    </div>
                    <div className="w-px bg-brand-pearl"></div>
                    <div>
                      <p className="font-heading font-black text-brand-red text-3xl">+30</p>
                      <p className="font-body text-brand-gray-mid text-xs uppercase tracking-wider">Colaboradores gestionados</p>
                    </div>
                    <div className="w-px bg-brand-pearl"></div>
                    <div>
                      <p className="font-heading font-black text-brand-red text-3xl">5</p>
                      <p className="font-body text-brand-gray-mid text-xs uppercase tracking-wider">Modalidades deportivas</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        ))}

        {/* Empty slots */}
        <AnimatedSection delay={100}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {[1, 2, 3, 4].map((n) => (
              <div
                key={n}
                className="border border-dashed border-brand-gray-mid/30 rounded-lg flex items-center justify-center p-8 h-32"
              >
                <p className="font-body text-brand-gray-mid text-xs text-center">
                  Próximo colaborador
                </p>
              </div>
            ))}
          </div>
        </AnimatedSection>

        {/* CTA become collaborator */}
        <AnimatedSection delay={150}>
          <div
            className="rounded-lg p-12 flex flex-col md:flex-row items-center justify-between gap-8"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-6 h-0.5" style={{ backgroundColor: "#E8150C" }}></div>
                <span className="font-body text-brand-red text-xs font-medium tracking-widest uppercase">
                  Únete a la red
                </span>
              </div>
              <h3 className="font-heading font-black text-brand-black text-3xl mb-2">
                ¿QUIERES SER COLABORADOR?
              </h3>
              <p className="font-body text-brand-gray-mid text-sm leading-relaxed max-w-md">
                Si compartes nuestra filosofía de profesionalización del deporte amateur, escríbenos. Estamos abiertos a sumar partners que aporten valor real al ecosistema.
              </p>
            </div>
            <Link
              to="/#contacto"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById("contacto");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className="flex-shrink-0 bg-brand-red hover:bg-brand-red-hover text-white font-body font-medium px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Escríbenos
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}